import customFetch from "../util/config/axiosConfig";
import { ApiResponse } from "../types/responseType";
import { toast } from "sonner";
import { getErrorMessage } from "../util/functions/UniversalFunctions";
import {
  MessageData,
  MessagePayload,
  PaginatedMessageResponse,
} from "../types/messageType";

const messagesApis = {
  //post
  createMessage: async (
    payload: MessagePayload,
  ): Promise<ApiResponse<MessagePayload> | undefined> => {
    try {
      const response = await customFetch.post(
        "/api/v1/messages/send",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error: any) {
      console.error("Error while adding message:", error);
      toast.error(getErrorMessage(error) || "Failed to add message");
    }
  },

  // GET
  getMessages: async (params: {
    branchCode: string;
    page: number;
    size: number;
    staffId?: number;
    studentId?: number;
    message?: string;
    messageType?: "SENT" | "RECEIVED" | "OTHER";
  }): Promise<ApiResponse<PaginatedMessageResponse> | undefined> => {
    try {
      const response = await customFetch.get("/api/v1/messages/filter", {
        params,
      });

      return response.data;
    } catch (error: any) {
      console.error("Error while fetching message:", error);
      toast.error(getErrorMessage(error) || "Failed to load Message");
    }
  },

  deleteMessage: async (messageId: number) => {
    try {
      const response = await customFetch.delete(`/api/v1/messages/delete-message/${messageId}`);

      return response.data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to delete message");
      throw err;
    }
  },
};

export default messagesApis;
